import * as yup from 'yup'
import { pt } from 'yup-locale-pt'

yup.setLocale(pt)
export const schemaPipelines = yup.object().shape({
  id: yup.string(),
  nomePipeline: yup
    .string()
    .required('Nome da pipeline é obrigatório')
    .label('Nome da pipeline'),
  descricao: yup
    .string()
    .required('Descrição é obrigatória')
    .label('Descrição'),
  centroCustoId: yup
    .string()
    .transform((_, val) => (val ? val : ''))
    .required('Centro de custo é obrigatório')
    .label('Centro de custo'),
  quantidadeLeads: yup.number().notRequired().label('Máximo de leads'),
  site: yup.boolean().required().label('Site')
})

export const schemaEtapas = yup.object().shape({
  id: yup.string(),
  nome: yup
    .string()
    .required('Nome da etapa é obrigatório')
    .label('Nome da etapa'),
  descricao: yup
    .string()
    .required('Descrição é obrigatória')
    .label('Descrição'),
  cor: yup.string().required('Cor da etapa é obrigatória').label('Cor'),
  etapasPermitidas: yup
    .array()
    .test(
      'etapasPermitidas',
      'Selecione ao menos uma etapa permitida',
      (value) => Array.isArray(value) && value.length >= 0
    )
    .required('Etapas permitidas é obrigatório')
    .label('Etapas permitidas'),
  pipelineId: yup
    .string()
    .transform((_, val) => (val ? val : ''))
    .required('Pipeline é obrigatória')
    .label('Pipeline'),
  status: yup.boolean().required().label('Etapa ativa')
})

export const schemaSLAs = yup.object().shape({
  id: yup.string().nullable(),
  nome: yup.string().required('Nome do SLA é obrigatório').label('Nome do SLA'),
  descricao: yup
    .string()
    .required('Descrição é obrigatória')
    .label('Descrição'),
  pipelineId: yup
    .string()
    .transform((_, val) => (val ? val : ''))
    .required('Pipeline é obrigatória')
    .label('Pipeline'),
  pipelineEtapaId: yup
    .string()
    .transform((_, val) => (val ? val : ''))
    .required('Etapa é obrigatória')
    .label('Etapa'),
  prazo: yup
    .number()
    .typeError('Prazo em horas deve ser um número')
    .positive('Prazo em horas deve ser um número positivo')
    .integer('Prazo em horas deve ser um número inteiro')
    .required('Prazo em horas é obrigatório')
    .label('Prazo (horas)'),
  regrasEscalacao: yup
    .array()
    .of(
      yup.object().shape({
        id: yup.string().nullable(),
        disparaEm: yup
          .string()
          .required('Disparar em é obrigatório')
          .label('Disparar em (%)'),
        acaoId: yup
          .string()
          .transform((_, val) => (val ? val : ''))
          .required('Ação é obrigatória')
          .label('Ação'),
        mensagem: yup
          .string()
          .required('Mensagem é obrigatória')
          .label('Mensagem')
      })
    )
    .optional()
    .label('Regras de escalacão')
})
